import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { getInventory, getInventoryTypes } from 'Reducers/Inventory/actions'
import MerchandiseSectionView from '../component/MerchandiseSectionView'
import { hashObject } from '../../../../../../../Utils/Strings'
import { processInventoryMovements } from '../../../../../../../shared/inventory'
import { isPowerBankTypeName } from 'Utils/PowerBanks'

import { sort } from '../../../util'

const MerchandiseSection = ({
  ambassadorId,
  // redux
  ambassadorInventory,
  ambassadorInventoryClients,
  getInventory,
  getInventoryTypes,
}) => {
  const [filterClientId, setFilterClientId] = useState(null)
  const [sortBy, setSortBy] = useState({})
  const [
    processedAmbassadorInventory,
    setProcessedAmbassadorInventory,
  ] = useState(ambassadorInventory)

  useEffect(() => {
    getInventory(500, null, {
      ambassadorId,
      current: true,
    })
    getInventoryTypes()
  }, [ambassadorId])

  useEffect(() => {
    const data = sort({
      data: filterInventoryByClient({
        inventories: ambassadorInventory,
        clientId: filterClientId,
      }),
      sortBy,
    })

    setProcessedAmbassadorInventory(data)
  }, [filterClientId, sortBy, ambassadorInventory])

  /**
   * On change filter
   */
  const onChangeFilterByClient = (e, index, val) => setFilterClientId(val)

  /**
   * On change sort inventories
   *
   * @param type
   * @param columnName
   */
  const onChangeSort = (type, columnName) => {
    if (sortBy.columnName === columnName) {
      setSortBy({ ...sortBy, reverse: !sortBy.reverse })
    } else {
      setSortBy({ columnName, reverse: false })
    }
  }

  return (
    <MerchandiseSectionView
      ambassadorInventory={processedAmbassadorInventory}
      ambassadorInventoryClients={ambassadorInventoryClients}
      onChangeFilterByClient={onChangeFilterByClient}
      clientId={filterClientId}
      onChangeSort={onChangeSort}
      isPickUp={isPickUp}
      isDropOff={isDropOff}
    />
  )
}

const mapStateToProps = (state, { ambassadorId }) => {
  const ambassadorInventory = processAmbassadorInventory({
    state,
    ambassadorId,
  })
  return {
    sortBy: state.ambassadors.inventoryByClientIdSortBy,
    ambassadorInventory,
    ambassadorInventoryClients: state.clients.clientsList
      .map(c => ({ label: c.name, value: c.id }))
      .filter(option =>
        ambassadorInventory.find(item => {
          return item.client && item.client.id == option.value
        }),
      ),
  }
}

const mapDispatchToProps = {
  getInventory,
  getInventoryTypes,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MerchandiseSection)

// util
const processAmbassadorInventory = ({ state, ambassadorId }) => {
  const searchHash = hashObject({
    ambassadorId,
    current: true,
  })
  const searchObj = state.inventory.search[searchHash]

  const ids = (searchObj || {}).ids || []
  const inventoryItems = ids.map(id => state.inventory.inventoryItems[id])
  const citiesList = state.city.citiesList || []
  const clientsList = state.clients.clientsList || []
  const inventoryTypes = state.inventory.inventoryTypes || []
  // Map to a format the page is expecting

  const onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index
  }

  return (
    inventoryItems
      // Filter out flyers
      .filter(item => item.typeId != 3)
      // Power banks have their own section with the hold on each unit
      .filter(item => {
        const type = inventoryTypes.find(t => t.id == item.typeId)
        return !isPowerBankTypeName(type && type.name)
      })
      .filter(onlyUnique)
      .map(item => {
        const movements = state.inventory.movements[item.id] || []
        // Grab first city from movements
        const cityId = movements[0] ? movements[0].relatedCityId : null
        const city = citiesList.find(city => city.id == cityId)
        const client = clientsList.find(client => client.id == item.clientId)
        const type = inventoryTypes.find(type => type.id == item.typeId)

        // For time start find the first movement where it was given to the user
        const movementStart = movements.find(
          m => m.relatedUserId == ambassadorId,
        )

        const processedMovements = processInventoryMovements(movements)
        const movementGivenOut = processedMovements.find(
          m => m.movementTypeId == 2,
        )

        return {
          id: item.id,
          location: {
            name: 'n/a',
            city: city ? { name: city.name } : { name: 'n/a' },
          },
          client: client
            ? { name: client.name, id: client.id }
            : { name: 'n/a' },
          type: type ? { name: type.name } : { name: 'n/a' },
          timeStart: movementStart ? movementStart.dateTime : null,
          quantity: movementGivenOut ? movementGivenOut.quantity : 0,
          comments: movementGivenOut ? movementGivenOut.comments : '',
        }
      })
  )
}

const isPickUp = comments => comments === 'pickup'
const isDropOff = comments => comments === 'dropoff'
/**
 * Filter Inventory by client
 *
 * @param {Array} inventories
 * @returns {Array}
 */
const filterInventoryByClient = ({ inventories, clientId }) => {
  if (clientId) {
    return inventories.filter(item => {
      return item.client.id === clientId
    })
  }

  return inventories
}
